import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae5ff4c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "solution-info" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "en-title" }, "产品方案"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "PRODUCT SCHEME")
], -1))
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "gutter-box-title" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_row, { gutter: 30 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.companyList, (item) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                class: "gutter-row",
                span: 8
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "gutter-box",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/scheme`)))
                  }, [
                    _createElementVNode("img", {
                      src: 
                  item.coverImage
                    ? `https://gwht.scrzhy.com/${item.coverImage}`
                    : `/images/bg-banner.png`
                ,
                      alt: ""
                    }, null, 8, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.description), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}